module.exports = __webpack_public_path__ + "img/huodong.9ba316fb.png";